"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _styledComponents = require("styled-components");

var _map = _interopRequireDefault(require("lodash/map"));

var _analytics = _interopRequireWildcard(require("@eig-builder/core-utils/analytics"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var GlobalStore = _interopRequireWildcard(require("@eig-builder/core-utils/store"));

var _withModalContext = require("@eig-builder/module-modals/withModalContext");

var _moduleNotificationBarWithContext = require("@eig-builder/module-notification-bar-with-context");

var _moduleLocalization = require("@eig-builder/module-localization");

var _moduleModals = require("@eig-builder/module-modals");

var _authentication_alias = require("authentication_alias");

var _chatContainer = _interopRequireDefault(require("./containers/chat-container"));

var _BootstrapperContext = _interopRequireDefault(require("./contexts/BootstrapperContext"));

var _styles = require("@material-ui/core/styles");

var _muitheme = _interopRequireDefault(require("muitheme"));

var _stylisPluginExtraScope = _interopRequireDefault(require("stylis-plugin-extra-scope"));

var Bootstrapper =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Bootstrapper, _PureComponent);

  function Bootstrapper(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bootstrapper);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bootstrapper).call(this));

    _this.getStyleDiv = function () {
      var styleDivId = "styling-".concat((0, _runtimeConfigHelper.getRuntimeConfig)()._app);
      var styleDiv = document.getElementById(styleDivId);

      if (styleDiv) {
        return styleDiv;
      }

      styleDiv = document.createElement('div');
      styleDiv.setAttribute('id', styleDivId);
      document.body.appendChild(styleDiv);
      return styleDiv;
    };

    _this.renderMicrofrontend = function () {
      var _this$props = _this.props,
          translations = _this$props.translations,
          enableChat = _this$props.enableChat,
          children = _this$props.children;
      return _react["default"].createElement(_moduleLocalization.LocalizationContainer, {
        _localizeDebug: (0, _moduleLocalization.LocalizeDebugHelper)(),
        translations: translations
      }, _react["default"].createElement(_withModalContext.ModalContextProviderWrapper, null, _react["default"].createElement(_moduleNotificationBarWithContext.NotificationBarWrapperWithContext, null, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_moduleNotificationBarWithContext.NotificationBarContainer, {
        targetKey: "fullscreen"
      }), enableChat && _react["default"].createElement(_chatContainer["default"], null), children))));
    };

    _this.renderDefault = function () {
      var _this$props2 = _this.props,
          translations = _this$props2.translations,
          enableChat = _this$props2.enableChat,
          children = _this$props2.children;
      var AuthenticationContainerProps = _this.props.AuthenticationContainerProps || {};
      return _react["default"].createElement(_authentication_alias.AuthenticationContainer, (0, _extends2["default"])({}, AuthenticationContainerProps, {
        analyticsService: _this.analyticsService
      }), _react["default"].createElement(_moduleLocalization.LocalizationContainer, {
        _localizeDebug: (0, _moduleLocalization.LocalizeDebugHelper)(),
        translations: translations
      }, _react["default"].createElement(_react["default"].Fragment, null, enableChat && _react["default"].createElement(_chatContainer["default"], null), children)));
    };

    if (props.store) {
      _this.store = props.store;
    } else {
      _this.store = GlobalStore.create({
        reduxLogger: !process.env.isProd
      }, [_moduleModals.Reducers], props.preLoadedState);
    }

    if (props.muiTheme) {
      _this.muiTheme = props.muiTheme;
    } else {
      _this.muiTheme = (0, _styles.createMuiTheme)(_muitheme["default"]);
    } // Scope every modal to it's microfrontend


    if (props.isMicroFrontend) {
      _this.muiTheme.props.MuiModal = _this.muiTheme.props.MuiModal || {};
      _this.muiTheme.props.MuiModal.container = document.getElementById((0, _runtimeConfigHelper.getRuntimeConfig)()._app);
      _this.muiTheme.props.MuiPopover = _this.muiTheme.props.MuiPopover || {};
      _this.muiTheme.props.MuiPopover.container = document.getElementById((0, _runtimeConfigHelper.getRuntimeConfig)()._app);
    }

    if (props.analyticsService) {
      _this.analyticsService = props.analyticsService;
    } else {
      _this.analyticsService = new _analytics["default"]((0, _analytics.getDefaultLoggers)());
    } // trigger three


    (0, _map["default"])(props.eventsToDispatch, function (event) {
      _this.store.dispatch(event);
    });
    return _this;
  }

  (0, _createClass2["default"])(Bootstrapper, [{
    key: "render",
    value: function render() {
      var options = {
        analyticsService: this.analyticsService,
        defaultRoute: this.props.defaultRoute,
        store: this.store
      };
      var generateClassName = (0, _styles.createGenerateClassName)({
        productionPrefix: 'c',
        seed: this.props.appName
      });
      var stylisePlugins = this.props.isMicroFrontend ? [(0, _stylisPluginExtraScope["default"])("#".concat((0, _runtimeConfigHelper.getRuntimeConfig)()._app))] : [];
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_styledComponents.StyleSheetManager, {
        target: this.getStyleDiv(),
        stylisPlugins: stylisePlugins
      }, _react["default"].createElement(_BootstrapperContext["default"].Provider, {
        value: options
      }, _react["default"].createElement(_reactRedux.Provider, {
        store: this.store
      }, _react["default"].createElement(_styles.MuiThemeProvider, {
        theme: this.muiTheme
      }, _react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: this.muiTheme
      }, _react["default"].createElement(_styles.StylesProvider, {
        generateClassName: generateClassName
      }, this.props.isMicroFrontend ? this.renderMicrofrontend() : this.renderDefault())))))));
    }
  }]);
  return Bootstrapper;
}(_react.PureComponent);

Bootstrapper.propTypes = {
  appName: _propTypes["default"].string,
  analyticsService: _propTypes["default"].shape({
    trackPageView: _propTypes["default"].func.isRequired
  }),
  store: _propTypes["default"].shape({
    dispatch: _propTypes["default"].func.isRequired
  }),
  isMicroFrontend: _propTypes["default"].bool,
  muiTheme: _propTypes["default"].object,
  AuthenticationContainerProps: _propTypes["default"].object,
  loginUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  BaseRouterWrapper: _propTypes["default"].any,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  eventsToDispatch: _propTypes["default"].arrayOf(_propTypes["default"].object),
  enableChat: _propTypes["default"].bool,
  preLoadedState: _propTypes["default"].object,
  defaultRoute: _propTypes["default"].string.isRequired,
  translations: _propTypes["default"].object
};
Bootstrapper.defaultProps = {
  isMicroFrontend: false
};
var _default = Bootstrapper;
exports["default"] = _default;